export default __webpack_public_path__ + "static/media/army_111.977c19ac.jpg";